import { useState, useEffect } from 'react';

// Data alvo: 17/03/2026 às 19h30 no horário de Mato Grosso (UTC-4)
// Em UTC: 17/03/2026 23:30:00
const EVENT_DATE = new Date('2026-03-17T23:30:00Z');

function useCountdown() {
  const [timeLeft, setTimeLeft] = useState({ days: '00', hours: '00', minutes: '00', seconds: '00' });

  useEffect(() => {
    const calc = () => {
      const now = new Date();
      const diff = EVENT_DATE.getTime() - now.getTime();
      if (diff <= 0) {
        setTimeLeft({ days: '00', hours: '00', minutes: '00', seconds: '00' });
        return;
      }
      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);
      setTimeLeft({
        days: String(days).padStart(2, '0'),
        hours: String(hours).padStart(2, '0'),
        minutes: String(minutes).padStart(2, '0'),
        seconds: String(seconds).padStart(2, '0'),
      });
    };
    calc();
    const interval = setInterval(calc, 1000);
    return () => clearInterval(interval);
  }, []);

  return timeLeft;
}

export default function HeroSection() {
  const scrollToForm = () => {
    const element = document.getElementById('inscricao');
    if (element) element.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          alt="Fashion Background"
          className="w-full h-full object-cover object-top"
          src="https://public.readdy.ai/ai/img_res/b1e6f203c1c86f7f2e02323a22506a53.jpg"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/70 to-black/90"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-5 sm:px-6 lg:px-10 pt-24 pb-16 lg:pt-32 lg:pb-24">
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-12 lg:gap-16">
          <div className="flex-1 text-center lg:text-left">
            <div className="flex flex-col sm:flex-row lg:flex-row items-center justify-center lg:justify-start gap-2 sm:gap-3 mb-6 lg:mb-8">
              <span className="bg-gradient-to-r from-yellow-500 to-yellow-600 text-black px-4 py-1.5 rounded-full text-xs font-bold tracking-wider whitespace-nowrap flex items-center gap-1.5">
                <i className="ri-calendar-event-fill text-sm"></i>
                17/03 • 19h30
              </span>
              <span className="bg-white/10 backdrop-blur-sm text-white border border-white/20 px-4 py-1.5 rounded-full text-xs font-bold tracking-wider whitespace-nowrap flex items-center gap-1.5">
                <i className="ri-map-pin-fill text-yellow-500 text-sm"></i>
                TANGARÁ DA SERRA - MT
              </span>
            </div>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-black text-white mb-5 leading-tight">
              Sua Carreira na<br />
              Moda, TV e <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-yellow-600">Redes Sociais</span><br />
              Começa Aqui
            </h1>

            <p className="text-sm sm:text-base lg:text-lg text-gray-200 mb-2 font-light max-w-2xl mx-auto lg:mx-0">
              Seletiva Oficial <strong className="text-white font-semibold">Four Models</strong> em <strong className="text-yellow-500 font-bold">Tangará da Serra - MT</strong>
            </p>

            <p className="text-base sm:text-lg lg:text-xl text-white mb-8 lg:mb-10 font-semibold max-w-xl mx-auto lg:mx-0 leading-relaxed">
              Descubra se você ou seu filho(a) tem perfil para moda, TV e internet.
            </p>

            <div className="flex flex-col sm:flex-row lg:flex-row items-center justify-center lg:justify-start gap-4">
              <button onClick={scrollToForm} className="bg-gradient-to-r from-yellow-500 to-yellow-600 text-black px-8 sm:px-12 lg:px-14 py-4 lg:py-5 rounded-full text-base sm:text-lg lg:text-lg font-black hover:from-yellow-400 hover:to-yellow-500 transition-all duration-300 shadow-2xl hover:shadow-yellow-500/40 hover:scale-105 whitespace-nowrap cursor-pointer w-full sm:w-auto">
                QUERO PARTICIPAR
              </button>
              <p className="text-yellow-500/80 text-xs font-medium whitespace-nowrap">
                Inscrição gratuita • Sem experiência
              </p>
            </div>

            <div className="mt-10 lg:mt-12 flex items-center justify-center lg:justify-start gap-6 sm:gap-10 text-white">
              <div className="text-center">
                <div className="text-2xl sm:text-3xl lg:text-4xl font-black text-yellow-500">03–35</div>
                <div className="text-xs text-gray-300 mt-1">Anos</div>
              </div>
              <div className="w-px h-10 bg-gray-600"></div>
              <div className="text-center">
                <div className="text-2xl sm:text-3xl lg:text-4xl font-black text-yellow-500">100%</div>
                <div className="text-xs text-gray-300 mt-1">Gratuito</div>
              </div>
              <div className="w-px h-10 bg-gray-600"></div>
              <div className="text-center">
                <div className="text-2xl sm:text-3xl lg:text-4xl font-black text-yellow-500">0</div>
                <div className="text-xs text-gray-300 mt-1">Exp. Necessária</div>
              </div>
            </div>
          </div>

          <div className="hidden lg:flex flex-col items-center justify-center w-[380px] xl:w-[420px] flex-shrink-0">
            <div className="bg-black/70 backdrop-blur-md border border-yellow-500/30 rounded-3xl px-8 py-8 w-full shadow-2xl shadow-black/60">
              <CountdownWidget />
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-2xl text-yellow-500"></i>
      </div>
    </section>
  );
}

function CountdownWidget() {
  const { days, hours, minutes, seconds } = useCountdown();

  const scrollToForm = () => {
    const element = document.getElementById('inscricao');
    if (element) element.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <>
      <div className="mb-5">
        <div className="flex items-center justify-center gap-2 mb-3">
          <span className="text-red-500 text-base animate-pulse">🔴</span>
          <p className="text-white font-black text-base">
            Vagas restantes: <span className="text-red-400 text-2xl">23</span>
          </p>
        </div>
        <div className="flex justify-center gap-1 mb-2">
          {Array.from({ length: 30 }).map((_, i) => (
            <div
              key={i}
              className={`w-2 h-5 rounded-sm transition-all duration-700 ${i < 7 ? 'bg-green-500' : 'bg-white/10'}`}
            />
          ))}
        </div>
        <p className="text-gray-400 text-xs text-center">
          <span className="text-red-400 font-bold">23</span> de 30 vagas disponíveis
        </p>
      </div>

      <div className="flex items-center gap-3 mb-4 max-w-xs mx-auto">
        <div className="flex-1 h-px bg-yellow-500/20"></div>
        <i className="ri-time-fill text-yellow-500/60 text-sm"></i>
        <div className="flex-1 h-px bg-yellow-500/20"></div>
      </div>

      <div className="flex items-center gap-2 mb-3 justify-center">
        <i className="ri-fire-fill text-red-400 text-base animate-pulse"></i>
        <p className="text-white font-black text-sm text-center">
          Apenas <span className="text-red-400 text-xl">23</span> vagas restantes!
        </p>
        <i className="ri-fire-fill text-red-400 text-base animate-pulse"></i>
      </div>

      <p className="text-gray-400 text-xs font-semibold tracking-widest uppercase text-center mb-4">
        O evento começa em
      </p>

      <div className="flex items-center justify-center gap-2">
        <TimeUnit value={days} label="Dias" />
        <Separator />
        <TimeUnit value={hours} label="Horas" />
        <Separator />
        <TimeUnit value={minutes} label="Min" />
        <Separator />
        <TimeUnit value={seconds} label="Seg" />
      </div>

      <button onClick={scrollToForm} className="w-full mt-6 bg-gradient-to-r from-yellow-500 to-yellow-600 text-black py-3.5 rounded-full text-sm font-black hover:from-yellow-400 hover:to-yellow-500 transition-all duration-300 shadow-lg hover:scale-105 whitespace-nowrap cursor-pointer">
        GARANTIR MINHA VAGA
      </button>
    </>
  );
}

function TimeUnit({ value, label }: { value: string; label: string }) {
  return (
    <div className="flex flex-col items-center">
      <div className="bg-black/60 border border-yellow-500/30 rounded-xl w-16 h-16 flex items-center justify-center">
        <span className="text-2xl font-black text-yellow-400 tabular-nums">{value}</span>
      </div>
      <span className="text-gray-500 text-[10px] font-semibold mt-1.5 tracking-wider uppercase">{label}</span>
    </div>
  );
}

function Separator() {
  return <span className="text-yellow-500/60 text-xl font-black mb-4 select-none">:</span>;
}
